import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import MetricBarChart from "../charts/MetricBarChart";
import EthnicityBarChart from "../charts/EthnicityBarChart";

const DemographicMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Demographics data:", sortedMetrics);

    const d = sortedMetrics[0];
    const race = indicators.find((i: any) => i.id === 1088);
    const ethnicity = indicators.find((i: any) => i.id === 1072);
    const language = indicators.find((i: any) => i.id === 1114);
    const latinodescent = indicators.find((i: any) => i.id === 1113);

    return (
        <>
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 gap-4">
            
                {d.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}   
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}
            
                <div className="col-span-1 xxs:col-span-2 w-full">
                    {race &&
                        <MetricBarChart
                            metric={race}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-60" 
                            background="bg-white"
                            barColor="#1a3a67"
                            titleOverride="Race"
                            alphabetical={true}
                            leftMargin={40}
                            rightMargin={50}
                        />
                    }
                </div>

                <div className="col-span-1 xxs:col-span-2 w-full">
                    {race && ethnicity &&
                        <EthnicityBarChart
                            metric={ethnicity}
                            populationMetric={race}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-24"
                            background="bg-white"
                            svg={null}
                        />
                    }
                </div>

                <div className="col-span-1 xxs:col-span-2 w-full">
                    {latinodescent &&
                        <MetricBarChart
                            metric={latinodescent}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                            topFive={true}
                        />
                    }
                </div>

                <div className="col-span-1 xxs:col-span-2 w-full">
                    {language &&
                        <MetricBarChart
                            metric={language}
                            svg={null}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            height="h-40" 
                            background="bg-white"
                            barColor="#1a3a67"
                            topFive={true}
                        />
                    }
                </div>
            </div>
        </div>
        </>
    );
}

export default DemographicMetrics;